import { queryOptions } from "@tanstack/react-query";
import { APIFunction } from "../utils/apiFunction";

export function getSessionTokenQuery(sessionToken: string) {
    return queryOptions({
        queryKey: ["getTokenFromSessionToken"],
        queryFn: () => APIFunction.performSessionTokenAuthCheck(sessionToken),
    });
}

export function getVerifyCustomerTokenQuery(token: string) {
    return queryOptions({
        queryKey: ["getVerifyCustomerToken"],
        queryFn: () => APIFunction.verifyCustomerToken(token),
    });
}
